module.exports = __webpack_public_path__ + "img/ex17.fdf95671.png";